export default "__VITE_ASSET__D6_Z4VLU__"